import { API_AUTH_LOGIN } from '@/shared/constants/bff-endpoints';
import { LoginFormData } from '@/shared/lib/validation/login';


export class LoginError extends Error {
    constructor(
        public readonly status: number,
        message: string,
    ) {
        super(message);
        this.name = 'LoginError';
    }
}

export async function loginRequest (data: LoginFormData): Promise<void> {
    const response = await fetch(API_AUTH_LOGIN, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ email: data.email, password: data.password }),
    });

    if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new LoginError(response.status, body.error ?? 'unexpected server error');
    }
}
